module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAeCAMAAADjLDWuAAAANlBMVEUAAAD////////////////////////////////////////////////////////////////////xY8b8AAAAEXRSTlMA8KAQ0ICwMMCQYFC/QCBwb82ql/sAAAC6SURBVCjPpZPpEoMgDIQTDgmH2n3/ly3aVqQKdKb7x0m+BDmydEiHKTE4qaDpqkWhSC3f2HJOs3jrhZFlK6rV1hTfkduiSZ+wAcx8/llOqBKqUl4WDEewZkxtaYbRHW6BmTpiSA/HVrt77B8PpltNryNKa/OO9wIDS82CQISaG1SKIz5cXyBN7H84XwTiff/6ud9ENHqfP96XQmM++vMVO/PpcsIP5/vqj5T9kQ5/VNJtfxV/CoOl9ucTFS4Lshb5OYgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.png
// module id = PgLh
// module chunks = 1